/**
 * @Author: DJ
 * @Date:   2021-07-08 15:54:01
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-09-30 15:06:59
 */
import { createModel } from '@/store/tools';

const model = {
    namespace: 'member',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getMemberList': T('getMemberList'),
            'getMemberDetail': T('getMemberDetail'),
            'getRecommentType': T('getRecommentType'),
            'getRecommentList': T('getRecommentList'),
            'getScoreList': T('getScoreList'),
            'getMemberState': T('getMemberState'),

            'getCompanyList': T('getCompanyList'),
            'getCompanyListV2': T('getCompanyListV2'),
            'getCompanyDetail': T('getCompanyDetail'),
            'getCompanyAccount': T('getCompanyAccount'),
            'getCompanyAccountStatus': T('getCompanyAccountStatus'),
            'getTemplateList': T('getTemplateList'),

            'getCouponList': T('getCouponList'),
            'getEpFundCount': T('getEpFundCount'),
            'getCouponTypeList': T('getCouponTypeList'),
            'getEpFundDetails': T('getEpFundDetails'),
            'getEpTransTypeEnum':T('getEpTransTypeEnum'), // 类型
            'getPaymentChannelType':T('getPaymentChannelType'), // 支付方式
            'getOrderDeliveryTypeEnum':T('getOrderDeliveryTypeEnum'), // 业务类型
            'getEpAccountList':T('getEpAccountList') // 账号
        },
        actions: {
            'getMemberList': A('getMemberList'),
            'getMemberDetail': A('getMemberDetail'),
            'getRecommentType': A('getRecommentType', { enumName: 'UserReferrerTypeEnum' }),
            'getRecommentList': A('getRecommentList'),
            'getScoreList': A('getScoreList'),
            'getMemberState': A('getMemberState', { enumName: 'UserStatusEnum' }),

            'getCompanyList': A('getCompanyList'),
            'getCompanyListV2': A('getCompanyListV2'),
            'getCompanyDetail': A('getCompanyDetail'),
            'getCompanyAccount': A('getCompanyAccount'),
            'getCompanyAccountStatus': A('getCompanyAccountStatus'),
            'getTemplateList': A('getTemplateList'),

            'getCouponList': A('getCouponList'),
            'getEpFundDetails': A('getEpFundDetails'),
            'getCouponTypeList': A('getCouponTypeList'),
            'getEpTransTypeEnum':A('getEpTransTypeEnum',{ enumName: 'EpTransTypeEnum' }),
            'getPaymentChannelType':A('getPaymentChannelType',{ enumName: 'PaymentChannelEpType' }),
            'getOrderDeliveryTypeEnum':A('getOrderDeliveryTypeEnum',{ enumName: 'OrderDeliveryTypeEpEnum' }),
            'getEpAccountList':A('getEpAccountList'),
            'getEpFundCount':A('getEpFundCount'),
        },
        sagas: {
            'getMemberList': S('getMemberList', '/?cmd=com.xqxc.api.pig.mis.biz.account.UserAccountMisService.listUserAccountInfo'),
            'getMemberDetail': S('getMemberDetail', '/?cmd=com.xqxc.api.pig.mis.biz.account.UserAccountMisService.getUserBrokerInfo'),
            'getRecommentType': S('getRecommentType', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getRecommentList': S('getRecommentList', '/?cmd=com.xqxc.api.pig.mis.biz.account.UserAccountMisService.listUserReferrer'),
            'getScoreList': S('getScoreList', '/?cmd=com.xqxc.api.pig.mis.settle.SettleAccountDetailApiMisService.totalBalanceList'),
            'getMemberState': S('getMemberState', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),

            'getCompanyList': S('getCompanyList', '/?cmd=com.xqxc.api.pig.mis.biz.account.EnterpriseAccountMisService.listEnterpriseAccountInfo'),
            'getCompanyListV2': S('getCompanyListV2', '/?cmd=com.xqxc.api.pig.mis.biz.account.EnterpriseAccountMisService.listEnterpriseAccountInfoV2'),
            'getCompanyDetail': S('getCompanyDetail', '/?cmd=com.xqxc.api.pig.mis.biz.account.EnterpriseAccountMisService.getEnterpriseInfo'),
            'getCompanyAccount': S('getCompanyAccount', '/?cmd=com.xqxc.api.pig.mis.biz.account.EnterpriseAccountMisService.listEnterpriseChildInfo'),
            'getCompanyAccountStatus': S('getCompanyAccountStatus', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getTemplateList': S('getTemplateList', '/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderDeliveryFeeRuleMisService.enterpriseList'),

            'getCouponList': S('getCouponList', '/?cmd=com.xqxc.api.pig.mis.biz.user.marketing.CouponMisService.listCoupon'),
            'getCouponTypeList': S('getCouponTypeList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getEpTransTypeEnum':S('getEpTransTypeEnum','/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getPaymentChannelType':S('getPaymentChannelType','/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getOrderDeliveryTypeEnum':S('getOrderDeliveryTypeEnum','/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            // 'getEpAccountList':S('getEpAccountList','/?cmd=com.xqxc.api.pig.mis.settle.SettleAccountDetailApiMisService.epAccountList'),
            'getEpAccountList':S('getEpAccountList','/?cmd=com.xqxc.api.pig.mis.biz.account.EnterpriseAccountMisService.getPair'),
            'getEpFundDetails':S('getEpFundDetails','/?cmd=com.xqxc.api.pig.mis.settle.SettleAccountDetailApiMisService.epFundDetails'),
            'getEpFundCount':S('getEpFundCount','/?cmd=com.xqxc.api.pig.mis.settle.SettleAccountDetailApiMisService.epFundCount'),
        },
        reducers: {
            'getMemberList': R('getMemberList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getMemberDetail': R('getMemberDetail', {}),
            'getRecommentType': R('getRecommentType', []),
            'getRecommentList': R('getRecommentList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getScoreList': R('getScoreList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getMemberState': R('getMemberState', []),

            'getCompanyList': R('getCompanyList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getCompanyListV2': R('getCompanyListV2', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getCompanyDetail': R('getCompanyDetail', {}),
            'getCompanyAccount': R('getCompanyAccount', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getCompanyAccountStatus': R('getCompanyAccountStatus', []),
            'getTemplateList': R('getTemplateList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),

            'getCouponList': R('getCouponList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getCouponTypeList': R('getCouponTypeList', []),
            'getEpTransTypeEnum':R('getEpTransTypeEnum',[]),
            'getPaymentChannelType':R('getPaymentChannelType',[]),
            'getOrderDeliveryTypeEnum':R('getOrderDeliveryTypeEnum',[]),
            'getEpAccountList': R('getEpAccountList', []),
            'getEpFundDetails': R('getEpFundDetails', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getEpFundCount': R('getEpFundCount', {}),
        }
    })
};
export default createModel(model);